import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Rankings.css';

const Rankings = () => {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    totalItems: 0,
    totalPages: 1
  });
  
  // Filters
  const [jobFilter, setJobFilter] = useState('all');
  const [sortBy, setSortBy] = useState('level');
  
  useEffect(() => {
    const fetchRankings = async () => {
      try {
        setLoading(true);
        
        const res = await axios.get(
          `/api/rankings?page=${pagination.page}&limit=${pagination.limit}&job=${jobFilter}&sort=${sortBy}`
        );
        
        setPlayers(res.data.players);
        setPagination(res.data.pagination);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching rankings:', err);
        setLoading(false);
      }
    };
    
    fetchRankings();
  }, [pagination.page, pagination.limit, jobFilter, sortBy]);
  
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagination.totalPages) return;
    setPagination({...pagination, page: newPage});
  };
  
  const handleJobFilterChange = (e) => {
    setJobFilter(e.target.value);
    setPagination({...pagination, page: 1}); // Reset to first page on filter change
  };
  
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setPagination({...pagination, page: 1}); // Reset to first page on sort change
  };
  
  const getJobName = (jobId) => {
    // Simplified version - in a real implementation,
    // you would have a more comprehensive mapping
    const jobs = {
      0: 'Beginner',
      100: 'Warrior',
      110: 'Fighter',
      120: 'Page',
      130: 'Spearman',
      200: 'Magician',
      210: 'Wizard (Fire/Poison)',
      220: 'Wizard (Ice/Lightning)',
      230: 'Cleric',
      300: 'Bowman',
      310: 'Hunter',
      320: 'Crossbowman',
      400: 'Thief',
      410: 'Assassin',
      420: 'Bandit',
      500: 'Pirate',
      510: 'Brawler',
      520: 'Gunslinger'
    };
    
    return jobs[jobId] || 'Unknown';
  };
  
  if (loading && players.length === 0) {
    return <div className="spinner"></div>;
  }
  
  return (
    <div className="rankings-page">
      <div className="card">
        <div className="card-header">
          <h1>Player Rankings</h1>
          <div className="filter-controls">
            <div className="form-group">
              <label htmlFor="jobFilter">Class:</label>
              <select
                id="jobFilter"
                className="form-control"
                value={jobFilter}
                onChange={handleJobFilterChange}
              >
                <option value="all">All Classes</option>
                <option value="0">Beginner</option>
                <option value="100">Warrior</option>
                <option value="200">Magician</option>
                <option value="300">Bowman</option>
                <option value="400">Thief</option>
                <option value="500">Pirate</option>
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor="sortBy">Sort by:</label>
              <select
                id="sortBy"
                className="form-control"
                value={sortBy}
                onChange={handleSortChange}
              >
                <option value="level">Level</option>
                <option value="fame">Fame</option>
                <option value="job">Job</option>
              </select>
            </div>
          </div>
        </div>
        
        <table className="rankings-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Name</th>
              <th>Level</th>
              <th>Job</th>
              <th>Fame</th>
              <th className="hide-sm">Stats</th>
            </tr>
          </thead>
          <tbody>
            {players.map((player, index) => {
              const rank = (pagination.page - 1) * pagination.limit + index + 1;
              return (
                <tr key={player.id}>
                  <td>{rank}</td>
                  <td>
                    <Link to={`/player/${player.id}`} className="player-name">
                      {player.name}
                    </Link>
                  </td>
                  <td>{player.level}</td>
                  <td>{getJobName(player.job)}</td>
                  <td>{player.fame}</td>
                  <td className="hide-sm">
                    <div className="stats-summary">
                      <span>STR: {player.str}</span>
                      <span>DEX: {player.dex}</span>
                      <span>INT: {player.int}</span>
                      <span>LUK: {player.luk}</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        
        <div className="pagination">
          <button
            className="btn btn-dark"
            onClick={() => handlePageChange(1)}
            disabled={pagination.page === 1}
          >
            First
          </button>
          <button
            className="btn btn-dark"
            onClick={() => handlePageChange(pagination.page - 1)}
            disabled={pagination.page === 1}
          >
            Prev
          </button>
          
          <span className="page-info">
            Page {pagination.page} of {pagination.totalPages}
          </span>
          
          <button
            className="btn btn-dark"
            onClick={() => handlePageChange(pagination.page + 1)}
            disabled={pagination.page === pagination.totalPages}
          >
            Next
          </button>
          <button
            className="btn btn-dark"
            onClick={() => handlePageChange(pagination.totalPages)}
            disabled={pagination.page === pagination.totalPages}
          >
            Last
          </button>
        </div>
      </div>
    </div>
  );
};

export default Rankings;